<div class="dialog-shell">

    <!-- Header -->
    <div class="dialog-header">
        <div class="flex items-start gap-4">
            <!-- Text -->
            <div class="flex-1 min-w-0 pt-0.5">
                <h2 class="dialog-title">{{title}}</h2>
                <p class="dialog-message">Dokument zostanie wygenerowany w wybranym języku</p>
            </div>

            <!-- Close -->
            <button mat-icon-button
                    class="dialog-close"
                    (click)="close()"
                    aria-label="Zamknij">
                <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-4 !h-4"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Body -->
    <div class="dialog-body">
        <div class="lang-options">
            <button *ngFor="let lang of languages"
                    class="lang-option"
                    [class.selected]="selectedLang === lang.code"
                    (click)="select(lang.code)">
                <span class="lang-dot">
                    <mat-icon *ngIf="selectedLang === lang.code"
                              class="lang-dot-check"
                              [svgIcon]="'tabler_outline:check'"></mat-icon>
                </span>
                <span class="lang-label">{{lang.label}}</span>
            </button>
        </div>
    </div>

    <!-- Footer -->
    <div class="dialog-footer dialog-footer--info">
        <button (click)="close()" class="dialog-btn dialog-btn--ghost">Anuluj</button>
        <button (click)="confirm()" class="dialog-btn dialog-btn--primary">Generuj</button>
    </div>
</div>
